export const heroData = {
  title: '探索 luluca 的全部精彩',
  subtitle: 'luluca 是一款革新性的智能创作平台，融合 AI 技术与人性化设计，让每一位创作者都能轻松释放灵感，将想法变为现实。无论你是设计新手还是资深专家，luluca 都能成为你最得力的创作伙伴。',
  ctaPrimary: '免费开始使用',
  ctaSecondary: '了解更多',
};

export const featuresData = [
  {
    id: 'feature-1',
    icon: 'ri-brain-line',
    title: 'AI 智能辅助',
    description: '搭载先进的人工智能引擎，luluca 能够理解你的创作意图，智能推荐配色方案、排版布局和设计元素，让创作过程事半功倍。',
    imageSeq: 'feature-ai',
  },
  {
    id: 'feature-2',
    icon: 'ri-layout-masonry-line',
    title: '海量模板库',
    description: '超过 10,000 款精心设计的模板，涵盖社交媒体、商业演示、品牌设计等各类场景，一键套用，快速出图。',
    imageSeq: 'feature-templates',
  },
  {
    id: 'feature-3',
    icon: 'ri-team-line',
    title: '实时协作',
    description: '支持多人同时在线编辑，团队成员可以实时查看彼此的修改，评论互动，大大提升团队创作效率。',
    imageSeq: 'feature-collab',
  },
  {
    id: 'feature-4',
    icon: 'ri-smartphone-line',
    title: '全平台同步',
    description: 'Web、iOS、Android 多端数据实时同步，随时随地继续你的创作，灵感不再受设备限制。',
    imageSeq: 'feature-sync',
  },
  {
    id: 'feature-5',
    icon: 'ri-shield-check-line',
    title: '版权安全保障',
    description: '内置版权检测系统，自动识别素材来源，确保你的每一份作品都安全合规，放心发布到任何平台。',
    imageSeq: 'feature-security',
  },
  {
    id: 'feature-6',
    icon: 'ri-bar-chart-line',
    title: '数据分析洞察',
    description: '提供详尽的作品数据报告，包括观看量、互动率、转化效果等，帮助你持续优化创作策略。',
    imageSeq: 'feature-analytics',
  },
];

export const scenariosData = [
  {
    id: 'scenario-1',
    title: '社交媒体运营',
    description: '快速制作朋友圈海报、小红书封面、抖音短视频封面等社交媒体内容，保持品牌视觉一致性。',
    icon: 'ri-share-line',
  },
  {
    id: 'scenario-2',
    title: '商业演示文稿',
    description: '从产品发布到融资路演，luluca 帮你打造令人印象深刻的商业演示，让你的创意脱颖而出。',
    icon: 'ri-presentation-line',
  },
  {
    id: 'scenario-3',
    title: '品牌视觉设计',
    description: 'Logo 设计、品牌色板、视觉规范，一站式完成品牌视觉体系的搭建与维护。',
    icon: 'ri-palette-line',
  },
  {
    id: 'scenario-4',
    title: '教育培训素材',
    description: '轻松制作课件、教学图表、知识卡片，让教育内容更加生动有趣，提升学习效果。',
    icon: 'ri-book-open-line',
  },
];

export const testimonialsData = [
  {
    id: 'testimonial-1',
    name: '张明远',
    role: '独立设计师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20designer%20in%20casual%20attire%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20modern%20professional%20look&width=120&height=120&seq=avatar-t1&orientation=squarish',
    content: 'luluca 彻底改变了我的设计工作流。以前需要花几个小时排版调色，现在 AI 辅助几分钟就能搞定，而且效果超出预期。强烈推荐给每一位设计师！',
    rating: 5,
  },
  {
    id: 'testimonial-2',
    name: '李思涵',
    role: '新媒体运营经理',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20female%20marketing%20manager%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20confident%20smile%2C%20modern%20business%20casual&width=120&height=120&seq=avatar-t2&orientation=squarish',
    content: '作为每天要产出大量内容的运营人，luluca 的模板库简直是救星！一键套用模板，微调就能出图，效率提升了不止一倍。',
    rating: 5,
  },
  {
    id: 'testimonial-3',
    name: '王浩然',
    role: '创业公司 CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20entrepreneur%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20approachable%20expression%2C%20modern%20business%20attire&width=120&height=120&seq=avatar-t3&orientation=squarish',
    content: '创业初期预算有限，luluca 让我们不用请设计师也能产出高质量的视觉内容。从 pitch deck 到社交媒体素材，一个平台全搞定。',
    rating: 5,
  },
  {
    id: 'testimonial-4',
    name: '陈雨桐',
    role: '自由插画师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20female%20illustrator%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20creative%20vibe%2C%20artistic%20casual%20style&width=120&height=120&seq=avatar-t4&orientation=squarish',
    content: '最喜欢 luluca 的版权检测功能，再也不用担心素材侵权问题了。而且 AI 配色建议非常专业，经常给我带来新的灵感。',
    rating: 4,
  },
];

export const statsData = [
  { id: 'stat-1', value: '500万+', label: '全球用户' },
  { id: 'stat-2', value: '10万+', label: '设计模板' },
  { id: 'stat-3', value: '98%', label: '用户满意度' },
  { id: 'stat-4', value: '150+', label: '覆盖国家' },
];